import Account from './account'
import Dashboard from './dashboard'
import Icon from '@mui/icons-material/Group'
import Service from './service'
import User from './user'
import Setting from './setting'

export default class Admin {
  static Account = Account
  static Service = Service
  static User = User
  static Setting = Setting
  static Icon = Icon
  static Dashboard = Dashboard
}
